import iconBuySale from './img/icon-sale.svg';
import iconDeposit from './img/icon-deposit.svg';
import iconBuy from './img/icon-buy.svg';
import iconSell from './img/icon-sell.svg';
import iconWithdraw from './img/icon-withdraw.svg';
import iconInvestmentSoon from 'assets/img/dashboard/layout/img/icon-investment-soon.svg';


export const images = {
    buySale: iconBuySale,
    deposit: iconDeposit,
    buy: iconBuy,
    sell: iconSell,
    withdraw: iconWithdraw,
    investment: iconInvestmentSoon,
};